import React from 'react';
import styles from './CommunityPageSkeleton.module.css';

function CommunityPageSkeleton() {
  return (
    <div className={styles.communityPage}>
      <div className={styles.titleSkeleton}>
        <div className={styles.shimmer}></div>
      </div>

      <div className={styles.ranks}>
        {/* Highest Point Skeleton */}
        <section className={styles.rankSection}>
          <div className={styles.sectionHeaderSkeleton}>
            <div className={styles.shimmer}></div>
          </div>
          <div className={styles.rankList}>
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className={styles.rankItemSkeleton}>
                <div className={styles.rankPositionSkeleton}>
                  <div className={styles.shimmer}></div>
                </div>
                <div className={styles.userInfoSkeleton}>
                  <div className={styles.nameSkeleton}>
                    <div className={styles.shimmer}></div>
                  </div>
                  <div className={styles.usernameSkeleton}>
                    <div className={styles.shimmer}></div>
                  </div>
                </div>
                <div className={styles.valueSkeleton}>
                  <div className={styles.shimmer}></div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Most Summited Skeleton */}
        <section className={styles.rankSection}>
          <div className={styles.sectionHeaderSkeleton}>
            <div className={styles.shimmer}></div>
          </div>
          <div className={styles.rankList}>
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className={styles.rankItemSkeleton}>
                <div className={styles.rankPositionSkeleton}>
                  <div className={styles.shimmer}></div>
                </div>
                <div className={styles.userInfoSkeleton}>
                  <div className={styles.nameSkeleton}>
                    <div className={styles.shimmer}></div>
                  </div>
                  <div className={styles.usernameSkeleton}>
                    <div className={styles.shimmer}></div>
                  </div>
                </div>
                <div className={styles.valueSkeleton}>
                  <div className={styles.shimmer}></div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default CommunityPageSkeleton;
